import type { FC } from "react";

import { ImageBehaviour } from "@jti/core-components/components/ImageBehaviour";
import { DetailsBar } from "@jti/ui/components/DetailsBar";

import styles from "./ReferralStatsItem.module.scss";

export type ReferralStatsItemProps = {
  imageUrl: string;
  description: string;
  value: string | number;
  dataTestId?: string | number;
};

const ReferralStatsItem: FC<ReferralStatsItemProps> = ({ imageUrl, description, value, dataTestId }) => {
  return (
    <div data-testid={dataTestId}>
      <DetailsBar
        rightTitle={value}
        leftDescription=""
        rightDescription={description}
        leftItem={
          <div className={styles.imageContainer}>
            {/* TODO: remove native behaviour when ImageBehaviour will work for this case */}
            <ImageBehaviour className={styles.image} src={imageUrl} alt="image" nativeBehaviour />
          </div>
        }
      />
    </div>
  );
};

export default ReferralStatsItem;
